import { DEVICE } from "../constants";

export function detectDevice() {
    const ua = navigator.userAgent;
  
    if (/android/i.test(ua)) {
      return DEVICE.ANDROID;
    }
  
    if ((/iPad|iPhone|iPod/.test(ua) && navigator.maxTouchPoints > 0) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 0)) {
      return DEVICE.IOS;
    }
  
    return DEVICE.DESKTOP;
  }

  